import React from 'react';
import { SEGMENT_FILL, TRACK } from '../theme';
import { minSegment } from '../format';

/**
 * Horizontal stacked bar for a distribution across the severity ramp.
 *
 * Widths are data, so they are inline; everything else is a utility class. Segments narrower than ~3%
 * get a pixel floor, otherwise a 1.2% slice rounds away to an invisible sliver.
 */
const StackedShareBar = ({ segments, height = 26, radius = 'rounded-ds-sm' }) => (
  <div className={`flex overflow-hidden ${radius} ${TRACK}`} style={{ height }}>
    {segments.map((segment, index) => (
      <div
        key={segment.key || index}
        data-tip={segment.tip}
        className={SEGMENT_FILL[index % SEGMENT_FILL.length]}
        style={{ width: `${segment.length}%`, minWidth: minSegment(segment.length, 2) }}
      />
    ))}
  </div>
);

export default StackedShareBar;
